import regexList from "./utils/regexList";
import regexTest from "./utils/regexTest";

export default function isNepaliAddress(str, responseText) {
    const regVal = regexList.nepAddress.pattern;
    return regexTest(str, regVal, responseText) || regexList.nepAddress.response;
}